import { render } from "./sign-accepted.vue?vue&type=template&id=b20d905a&scoped=true"
import script from "./sign-accepted.vue?vue&type=script&lang=js"
export * from "./sign-accepted.vue?vue&type=script&lang=js"

import "./sign-accepted.vue?vue&type=style&index=0&id=b20d905a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20d905a"]])

export default __exports__